import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { DashboardChatProvider } from './context/DashboardChatContext';
import LoginForm from './pages/LoginForm';
import ProtectedRoute from './pages/ProtectedRoute';
import RoleProtectedRoute from './pages/RoleProtectedRoute';
import { SidebarProvider } from './components/ui/sidebar';
import { AppSidebar } from './components/app-sidebar';
import { AppHeader } from './components/app-header';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AppMainContent from './components/AppMainContent';
// import DashboardChatBot from './components/dashboard/DashboardChatBot';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" reverseOrder={false} />
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <RoleProtectedRoute>
                  <DashboardChatProvider>
                    <SidebarProvider>
                      <AppHeader />
                      <div className="flex min-h-screen">
                        <AppSidebar />
                        <main className="ml-20 mt-16 h-[calc(100vh-4rem)] flex-1 overflow-y-auto">
                          <AppMainContent />
                        </main>
                      </div>
                      {/* Analytics bot hidden for now */}
                      {/* <DashboardChatBot /> */}
                    </SidebarProvider>
                  </DashboardChatProvider>
                </RoleProtectedRoute>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
